import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs';

@Injectable()

export class AutosService extends BaseService{

  constructor(private http: HttpClient) { super(); }

  GetById(id: number){
      return this.http
      .get(this.UrlService + `autos/${id}`)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }

  GetByPlaca(placa, estadoId){
      return this.http
      .get(this.UrlService + `autos/GetByPlaca/${placa}/${estadoId}`)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }

  GetByRenavam(renavam: string){
      return this.http
      .get(this.UrlService + `autos/GetByRenavam/${renavam}`)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }

  salvarAuto(formAuto, itemId){
      return this.http
      .post(this.UrlService + `autos?itemId=${itemId}`, formAuto)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }

  getByItemId(itemId) {
    return this.http
      .get(this.UrlService + `autos/getByItemId/${itemId}`)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }
}
